/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Box, Grid, Stack, Typography, Grow, Drawer, Popper, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FaRegFileAlt } from 'react-icons/fa';
import { BsPlayBtn } from 'react-icons/bs';
import { useNavigate, useParams } from 'react-router-dom';
import MoveToSlider from '../../../BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/StatusContentSection/CategoriesView/Components/MoveToSlider';
import CategorySlider from '../../../BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/CategorySlider';
import subCategoryIcon from '../../../../assets/SvgIcons/resources/subCategory.svg';
import resourceMic from '../../../../assets/SvgIcons/resources/Categoryrecorder.svg';
import Preview from '../../../ResourceManagement/Components/DocViewer';
// import { CategoryData } from '../../../BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/StatusContentSection/CategoriesView/types';
import useResourceHelper from '../../../BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/Reusable/ContentCards/useResourceHelper';
import { EditCategories } from '../../../BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/StatusContentSection/CategoriesView/Components/EditCategories';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';

const StyledBox = styled(Box)(({ theme }) => ({
	'&:hover .edit-grid' : {
		display : 'block !important'
	}
}));

interface CategoriesCardProps {
	status?: string;
	shouldShowPopover?: boolean;
	ContentCategoryType?: boolean;
	ContentView?: any;
	category?: any; // Allow both CategoryData and network company data
	id?: string;
	onDeleteSuccess?: () => void;
	onMoveSuccess?: () => void;
}

const CategoriesCard = (props: CategoriesCardProps) =>
{
	const { status, ContentCategoryType, category, onDeleteSuccess,
		onMoveSuccess } = props;
	// const [ anchorEl, setAnchorEl ] = useState<HTMLElement | null>(null);
	// const open = Boolean(anchorEl);
	// const closePopoverTimeout = useRef<any>(null);
	// eslint-disable-next-line no-unused-vars
	// eslint-disable-next-line no-unused-vars
	const [ categoryData, setCategoryData ] = useState(category);
	const [ Moveto, setMoveto ] = useState(false);
	const [ EditCategory, setEditCategory ] = useState(false);
	const [ isCardVisible, setIsCardVisible ] = useState(true);
	const location = window.location.pathname;
	const [ categoryType, setCategoryType ] = useState('categoryData');
	const cardRef = useRef<HTMLDivElement | null>(null);
	// const [ cardWidth, setCardWidth ] = useState(320);
	const [ previewOpen, setPreviewOpen ] = useState(false);
	const [ imgError, setImgError ] = useState(false);
	const navigate = useNavigate();
	const { isAdminView, getRandomBackgroundImage } = useResourceHelper();
	// const showPopover = isAdminView;
	const type = useParams()?.type;
	const isCompanyList = location === '/resource/network/companies';
	const companyId = useParams()?.companyId;
	const categoryId = useParams()?.categoryId;

	const thumbnailUrl = useMemo(() =>
	{
		if (location === '/resource/network/companies')
		{
			return `${process.env.REACT_APP_S3_BASE_URL}/profile/${categoryData?.companyId}_logo_thumbnail.jpeg`;
		}
		if (categoryData?.thumbnailUrl)
		{
			return categoryData?.thumbnailUrl;
		}
	}, [ categoryData, category ]);

	const bottom = [
		{ tooltip: 'sub category', icon: subCategoryIcon, count: categoryData?.subcategoryCount || 0, type: 'img' },
		{ tooltip: 'articles', icon: '/images/icons/ArticleContent.svg', count: categoryData?.contentCount?.articles || categoryData?.count?.article || 0, type: 'img' },
		{ tooltip: 'videos', icon: <BsPlayBtn fontSize={10} />, count: categoryData?.contentCount?.videos || categoryData?.count?.video || 0 },
		{ tooltip: 'podcasts', icon: resourceMic, count: categoryData?.contentCount?.podcasts || categoryData?.count?.podcast || 0, type: 'img' },
		{ tooltip: 'documents', icon: <FaRegFileAlt fontSize={10} />, count: categoryData?.contentCount?.documents || categoryData?.count?.document || 0 }
	];
	const categoryName = categoryData?.name || categoryData?.companyName;
	const isCategoryEnabled = isCompanyList || (categoryData?.isEnabled ?? status === 'Enabled');
	const uncategorizedId = useSelector((state: any) => state.myresource?.uncategorizedId);

	// const handleMouseEnter = (event) =>
	// {
	// 	if (closePopoverTimeout.current) clearTimeout(closePopoverTimeout.current);

	// 	// Prevent popover from showing when MoveToSlider is open
	// 	if (showPopover && !Moveto && !EditCategory)
	// 	{
	// 		if (cardRef.current)
	// 		{
	// 			setCardWidth(cardRef.current.offsetWidth); // Recalculate card width
	// 		}

	// 		setAnchorEl(event.currentTarget);
	// 	}
	// };

	// const handleMouseLeave = () =>
	// {
	// 	closePopoverTimeout.current = setTimeout(() =>
	// 	{
	// 		setAnchorEl(null);
	// 	}, 0);
	// };

	const handlemOpenMovetoSlider = (event) =>
	{
		setMoveto(true);
		event.stopPropagation();
		// setAnchorEl(null);
	};
	const handlemCloseMovetoSlider = (event) =>
	{
		setMoveto(false);
		event.stopPropagation();
	};

	const handleEditCategory = (event) =>
	{
		setEditCategory(true);
		setCategoryType('categoryData');
		event.stopPropagation();
		// setAnchorEl(null);
	};

	useEffect(() =>
	{
		if (category)
		{
			setCategoryData(category);
		}
	}, [ category ]);

	useEffect(() =>
	{
		const enableScroll = () =>
		{
			document.body.style.overflow = 'auto';
		};

		window.addEventListener('scroll', enableScroll);

		return () =>
		{
			window.removeEventListener('scroll', enableScroll);
		};
	}, []);

	// useEffect(() =>
	// {
	// 	if (!isCardVisible)
	// 	{
	// 		// If card should be hidden, update its display style
	// 		if (cardRef.current)
	// 		{
	// 			cardRef.current.style.display = 'none';
	// 		}
	// 	}
	// }, [ isCardVisible ]);

	// const handleClick = (event) =>
	// {
	// 	event.stopPropagation();
	// 	event.preventDefault();
	// };
	// const [ placement, setPlacement ] = useState<'left' | 'right'>('left');
	// const [ translateX, setTranslateX ] = useState(-320);
	// const [ translateY, setTranslateY ] = useState(0);

	// useEffect(() =>
	// {
	// 	if (open && anchorEl)
	// 	{
	// 		const rect = anchorEl.getBoundingClientRect();
	// 		const windowWidth = window.innerWidth;
	// 		const windowHeight = window.innerHeight;
	// 		let newPlacement: 'left' | 'right' = 'left';
	// 		let newTranslateX = 0;
	// 		let newTranslateY = 0;

	// 		if (rect.left < 0)
	// 		{
	// 			newPlacement = 'right';
	// 			newTranslateX = rect.width + 10;
	// 		}
	// 		if (rect.bottom + 200 > windowHeight)
	// 		{
	// 			if (windowWidth >= 1200)
	// 			{
	// 				newTranslateY = Math.max(-90, -(rect.bottom + 200 - windowHeight));
	// 			}
	// 			else if (windowWidth >= 768)
	// 			{
	// 				newTranslateY = Math.max(-130, -(rect.bottom + 200 - windowHeight));
	// 			}
	// 			else
	// 			{
	// 				newTranslateY = Math.max(-20, -(rect.bottom + 200 - windowHeight));
	// 			}
	// 		}

	// 		setPlacement(newPlacement);
	// 		setTranslateX(newTranslateX);
	// 		setTranslateY(newTranslateY);
	// 	}
	// }, [ open, anchorEl ]);

	// useEffect(() =>
	// {
	// 	if (cardRef.current)
	// 	{
	// 		setCardWidth(cardRef.current.offsetWidth);
	// 	}
	// }, []);

	// useEffect(() =>
	// {
	// 	const updateWidth = () =>
	// 	{
	// 		if (cardRef.current)
	// 		{
	// 			setCardWidth(cardRef.current.offsetWidth);
	// 		}
	// 	};

	// 	window.addEventListener('resize', updateWidth);
	// 	updateWidth(); // Set initial width

	// 	return () =>
	// 	{
	// 		window.removeEventListener('resize', updateWidth);
	// 	};
	// }, []);
	const handleImagePreview = () =>
	{
		setPreviewOpen(true);
	};
	const handleClosePreview = () =>
	{
		setPreviewOpen(false);
	};

	const handleImageError = () =>
	{
		setImgError(true);
	};

	const handleCategoryClick = () =>
	{
		// Extract inline conditions into variables
		const isResourceCategoriesPage = [ '/resource/categories', '/resource' ].includes(window.location.pathname);
		const isSearchingInsideCategory = window.location.pathname.includes('/resource/categories/') && categoryId;
		const isResourceCategoriesOrSearch = isResourceCategoriesPage || isSearchingInsideCategory;

		const isNetworkCompaniesPage = window.location.pathname.includes('/resource/network/companies');
		const isNetworkCompaniesWithoutTypeOrCompanyId = category?.companyId && isNetworkCompaniesPage && !type && !companyId;

		const isNetworkCompanies = window.location.pathname.includes('/resource/network/companies/');
		const isCompanyProfile = window.location.pathname.includes('/connections/companyprofile');
		const isCategoriesTypeOrHasCategoryId = type === 'categories' || category?._id;
		const isNetworkCompaniesCategories = (isNetworkCompanies || isCompanyProfile) && isCategoriesTypeOrHasCategoryId;

		if (isAdminView)
		{
			navigate(`/businessSettings/content/categories/${category?._id}`);
		}
		else if (isResourceCategoriesOrSearch)
		{
			// for categories
			navigate(`/resource/categories/${category?._id}`);
		}
		else if (isNetworkCompaniesWithoutTypeOrCompanyId)
		{
			// for network companies
			navigate(`/resource/network/companies/${category?.companyId}`);
		}
		else if (isNetworkCompaniesCategories)
		{
			// for network companies categories
			const query = isCompanyProfile ? '?from=company_profile' : '';

			navigate(`/resource/network/companies/${category?.companyId}/categories/${category?._id}${query}`);
		}
	};

	// // Reusable function to generate content URLs
	// const generateContentUrl = (): string =>
	// {
	// 	if (category?._id)
	// 	{
	// 		return isAdminView
	// 			? `${window.location.origin}/businessSettings/content/categories/${category._id}`
	// 			: `${window.location.origin}/resource/categories/${category._id}`;
	// 	}

	// 	return '';
	// };
	// const viewIndividual = (): void =>
	// {
	// 	const link = generateContentUrl();

	// 	if (link)
	// 	{
	// 		navigate(link.replace(window.location.origin, ''));
	// 	}
	// };

	const generateResourceUrl = (): string =>
	{
		// only for categories
		if (category?._id)
		{
			return `${window.location.origin}/resource/categories/${category._id}`;
		}

		return '';
	};

	const handleCopyLink = (e: React.MouseEvent<HTMLElement>): void =>
	{
		e.stopPropagation();
		const link = generateResourceUrl();

		if (link)
		{
			navigator.clipboard.writeText(link)
				.then(() =>
				{
					toast.success('Link copied to clipboard!');
					console.log('Link copied to clipboard:', link);
				})
				.catch((error) =>
				{
					console.error('Failed to copy link:', error);
					toast.error('Failed to copy link to clipboard');
				});
		}
	};

	return (
		<>
			<Grow in={isCardVisible} timeout={400}>
				<StyledBox
					ref={cardRef}
					bgcolor='#fff'
					borderRadius='8px'
					border='1px solid #D5D5D5'
					height='100%'
					display={isCardVisible ? 'flex' : 'none'}
					flexDirection='column'
					position='relative'
					onClick={handleCategoryClick}
					// {...(
					// 	showPopover && {
					// 		onMouseEnter : (event) => handleMouseEnter(event),
					// 		onMouseLeave : handleMouseLeave
					// 	}
					// )}
					sx={{ cursor: 'pointer' }}
				>
					{((categoryData?.name !== 'Uncategorized') || (categoryData?._id !== uncategorizedId)) &&
					<Grid
						className='edit-grid'
						item sx={{
							position : 'absolute',
							top      : '8px',
							right    : '8px',
							zIndex   : 1,
							display  : 'none' // Hidden by default, shown on hover
						}}
					>
						<EditCategories
							handlePreview={handleImagePreview}
							ContentCategoryType={ContentCategoryType}
							type={'category'}
							// StatusTxtMsg={StatusTxtMsg}
							category={categoryData}
							setCategoryData={setCategoryData}
							handleEditCategory={handleEditCategory}
							// handlemOpenplaylisttoSlider={handlemOpenplaylisttoSlider}
							handlemOpenMovetoSlider={handlemOpenMovetoSlider}
							onDeleteSuccess={onDeleteSuccess}
							handleCopyLink={handleCopyLink}
						/>
					</Grid>
					}
					<Box
						sx={{
							position     : 'relative',
							width        : '100%',
							aspectRatio  : '16 / 9',
							overflow     : 'hidden',
							borderRadius : '8px 8px 0px 0px'
						}}
					>
						<Box
							component='img'
							src={imgError ? getRandomBackgroundImage : (thumbnailUrl || getRandomBackgroundImage)}
							position='absolute'
							width='100%'
							height='100%'
							alt=''
							onError={handleImageError}
							borderRadius='8px 8px 0px 0px'
							sx={{
								objectFit  : 'cover',
								transition : 'transform 0.3s ease-in-out',
								opacity    : !isCategoryEnabled ? 0.5 : null,
								'&:hover'  : { transform: 'scale(1.1)' }
							}}
						/>
						{(imgError || !thumbnailUrl) && categoryName && location !== '/resource/network/companies' &&
						<Box py={0.5} px={1.5} position='absolute' top={'25%'}>
							<Typography
								fontSize='22px'
								fontWeight={500}
								color='#256EA6'
								sx={{
									display         : '-webkit-box',
									WebkitBoxOrient : 'vertical',
									WebkitLineClamp : 2,
									overflow        : 'hidden',
									textOverflow    : 'ellipsis',
									opacity        	: '0.5'
								}}
							>
								{categoryName}
							</Typography>

						</Box>
						}
						{/* {status && */}
						{isAdminView &&
						<Box borderRadius='0px 12px 12px 0px' py={0.5} px={1.5} position='absolute' top='12px' bgcolor={isCategoryEnabled ? '#D2EFE1' : '#E6E6E6'}>
							<Typography fontSize='12px'>{isCategoryEnabled ? 'Enabled' : 'Disabled'}</Typography>
						</Box>}
						{/* } */}
					</Box>

					{location === '/resource/network/companies'
						? <Stack direction='row' display='flex' alignItems='center' justifyContent={'space-between'} spacing={1} px={1} mt={1}>
							<Typography fontWeight='500'>{categoryData?.companyName}</Typography>
							<Box display={'flex'} flexDirection={'row'} gap={1}>
								<Box src='/images/icons/partner.svg' component={'img'} width={20} height={20}/>
								<Typography fontSize='14px'>{categoryData?.relationName}</Typography>
							</Box>
						</Stack>
						: <Typography color='#283C50' fontWeight='500' px={1} pt={1} sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
							{categoryName}
						</Typography>}
					<Grid item p={1} mb={0.5} sx={{ mt: 'auto' }}>
						<Grid container justifyContent='space-between' sx={{ cursor: 'pointer', alignItems: 'center', justifyContent: 'flex-end' }}>
							{bottom.map((value, index) => (
								<React.Fragment key={index}>
									<Grid item display='flex' alignItems='center' xs color='#6B7280'>
										<Tooltip
											title={value.tooltip}
											placement='top'
											arrow
											// enterDelay={100}
											leaveDelay={200}
										>
											<Stack direction='row' display='flex' alignItems='center' spacing={0.5} sx={{ cursor: 'pointer' }}>
												{value.type !== 'img'
													? <Box>{value.icon}</Box>
													: <Box component='img' src={typeof value.icon === 'string' ? value.icon : ''} alt={'index'} width={12} height={12}/>}
												<Typography variant='inherit' fontSize='10px'>{value.count}</Typography>
											</Stack>
										</Tooltip>
									</Grid>
									{index < bottom.length - 1 && <Box sx={{ height: '12px', width: '1px', backgroundColor: '#D5D5D5', mr: 1, alignSelf: 'center' }} />}
								</React.Fragment>
							))}
						</Grid>
					</Grid>
					{/* <Popper
						open={open}
						anchorEl={anchorEl}
						disablePortal
						placement={placement}
						onClick={handleClick}
						modifiers={[
							{
								name    : 'preventOverflow',
								options : { boundary: 'window', padding: 8 }
							},
							{
								name    : 'flip',
								options : {
									fallbackPlacements : [ 'left', 'right' ]
								}
							},
							{
								name    : 'offset',
								options : { offset: [ 0, 10 ] }
							},
							{
								name    : 'computeStyles',
								options : {
									adaptive        : true,
									gpuAcceleration : true
								}
							}
						]}
						sx={{
							zIndex              : 9,
							width               : cardWidth,
							backgroundImage     : `url('${thumbnailUrl || getRandomBackgroundImage}')`,
							backgroundSize      : 'cover',
							backgroundPosition  : 'center',
							backgroundRepeat    : 'no-repeat',
							backgroundBlendMode : 'overlay',
							bgcolor             : 'rgba(0, 0, 0, 0.8)',
							color               : 'white',
							p                   : 2,
							borderRadius        : 2,
							boxShadow           : '0px 2px 4px rgba(0, 0, 0, 0.2)',
							transform           : `translate3d(${translateX}px, ${translateY}px, 0px) !important`,
							'&::before'         : !isCategoryEnabled
								? {
									content      : '""',
									position     :	'absolute',
									top          : 0,
									left         : 0,
									width        : '100%',
									height       : '100%',
									filter       : 'blur(20px)',
									zIndex       : -1,
									borderRadius : 2,
									background   : 'rgba(255, 255, 255, 0.3)'

								}
								: {}
						}}
					>
						<PopoverContentView
							handlemOpenMovetoSlider={handlemOpenMovetoSlider}
							handleEditCategory={handleEditCategory}
							handleDeleteCategory={handleDeleteCategory}
							ContentCategoryType={ContentCategoryType}
							status={categoryData?.isEnabled ? 'Enabled' : 'Disabled'}
							handleImagePreview={handleImagePreview}
							category={categoryData}
							setCategoryData={setCategoryData}
							onDeleteSuccess={onDeleteSuccess}
							fromType='category'
							type='category'
							isAdminView={isAdminView}
						/>
					</Popper> */}
					{previewOpen &&
					<Preview
						previewDoc={{ url: 'https://cdn.pixabay.com/photo/2024/06/18/13/20/woman-8838032_1280.jpg' }}
						mediaType={'image'}
						handleClosePreview={handleClosePreview}
					/>}
				</StyledBox>
			</Grow>
			<Drawer anchor='right' open={Moveto} onClose={handlemCloseMovetoSlider}
				PaperProps={{
					sx : {
						width : {
							xs : 'var(--percent100)',
							sm : '70%',
							md : '40%',
							lg : '30%'

						}
					}
				}}
			>
				<MoveToSlider
					onClose={() => setMoveto(false)}
					sourceCategoryId={categoryData?._id || ''}
					sourceCategoryName={categoryData?.name || ''}
					onMoveSuccess={(targetCategoryId, targetCategoryName) =>
					{
						console.log(`Category moved to ${targetCategoryName}`);
						onMoveSuccess?.();
					}}
					onMoveError={(error) =>
					{
						console.error('Move failed:', error);
					}}
				/>
			</Drawer>
			<Drawer anchor='right' open={EditCategory} onClose={() => setEditCategory(false)}
				sx={{ zIndex: '1015 !important' }}
				PaperProps={{
					sx : {
						width : {
							xs : 'var(--percent100)',
							sm : '70%',
							md : '50%',
							lg : '35%'
						}
					}
				}}
			>
				<CategorySlider
					categoryType={categoryType as 'category' | 'categoryData' | 'playlist' | 'subcategory'}
					sliderEdit
					category={categoryData}
					setCategoryData={setCategoryData}
					toggleCategory={() => setEditCategory(false)}
				/>
			</Drawer>
		</>
	);
};

export default CategoriesCard;
